import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getConfig } from "plugins/config-loader";
import { mapBackendUserPreferencesToUserPreferences as adaptBackendUserPreferencesToFrontend, mapUserPreferencesToBackendUserPreferences as adaptFrontendUserPreferencesToBackend } from "./mapper";
export const userPreferencesModuleName = "settings";
export const userPreferencesApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: `${getConfig("REACT_APP_USERS_BACKEND_BASE_URL")}`,
        prepareHeaders: (headers, { extra, getState }) => {
            const state = getState();
            const token = extra.getStateValue(state, "accessToken");
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            return headers;
        }
    }),
    endpoints: (builder) => ({
        fetchCurrentUser: builder.query({
            query: () => ({
                method: "GET",
                url: "/users/current-user"
            }),
            transformResponse: (response) => ({
                firstName: response?.firstName ?? "",
                lastName: response?.lastName ?? ""
            })
        }),
        fetchUserPreferences: builder.query({
            providesTags: ["UserPreferences"],
            query: () => ({
                method: "GET",
                url: "/users/preferences"
            }),
            transformResponse: (response) => adaptBackendUserPreferencesToFrontend(response?.preferences)
        }),
        patchUserPreferences: builder.mutation({
            invalidatesTags: ["UserPreferences"],
            query: (request) => ({
                body: adaptFrontendUserPreferencesToBackend(request),
                method: "PATCH",
                url: "/users/preferences"
            }),
            transformResponse: (response) => adaptBackendUserPreferencesToFrontend(response)
        })
    }),
    reducerPath: "userPreferencesApi",
    tagTypes: ["UserPreferences"]
});
export const { middleware: userPreferencesApiMiddleware, reducer: userPreferencesApiReducer, reducerPath: userPreferencesApiReducerPath, useFetchCurrentUserQuery, useFetchUserPreferencesQuery, usePatchUserPreferencesMutation } = userPreferencesApi;
export const getUserPreferencesRaw = userPreferencesApi.endpoints.fetchUserPreferences.matchFulfilled;
export const usePatchUserPreferences = userPreferencesApi.endpoints.patchUserPreferences.matchFulfilled;
